// Declarations API — endpoints injected into the single baseApi (ARCHITECTURE §7).
import { baseApi } from '@/lib/api/baseApi';
import { declarationsEndpoints } from './declarations.queries';

export const declarationsApi = baseApi.injectEndpoints({ endpoints: declarationsEndpoints });

export const {
  useGetIncomingDeclarationsQuery,
  useGetDeclarationFilterOptionsQuery,
  useGetDeclarationQuery,
  useGetDeclarationOverviewQuery,
  useGetDeclarationDetailsTabQuery,
  useGetDeclarationAllocationsQuery,
  useUpdateDeclarationEmissionsMutation,
  useDeleteDeclarationEmissionsMutation,
  useGetLinkedShipmentsForDeclarationQuery,
  useGetDeclarationAttachmentsQuery,
  useGetDeclarationEmissionCalculationsQuery,
  useValidateDeclarationMutation,
  useEditDeclarationMutation,
  useDeleteDeclarationMutation,
  useRetryDeclarationExtractionMutation,
  useGetTakenDeclarationFilenamesQuery,
  useGetShipmentForAddDeclarationsQuery,
  useUploadDeclarationsMutation,
  useAddDeclarationsToShipmentMutation,
} = declarationsApi;
